<template>
<div id="Contact">
    <br><br> <br><br>
    <br>
   <div class="title is-3 center this-content">Contact </div>
    <hr> <br><br>
    <div class="is-3 pad text">
        <U><b>CALL</b></U><br>
        +254779477821&#9822;
        <br>
        +254741192882</div>
   <div class="katikati"><a href="mailto: nelsonomondi99@gmail.com"> nelsonomondi99@gmail.com</a>&#128231;</div>
</div>
<br><br>
</template>

<script>
export default {
    name: 'ContactComponent',
}
</script>

<style>
.text {
    text-align: center;
    justify-content: center;
}

.katikati {
    text-align: center;
    justify-content: center;
    align-items: center;
    text-transform: capitalize;
    font-size: x-larger;

}.this-content{
    font-weight: bold;
    font-size: x-large;
    text-decoration: underline;
}
.Contact{
    padding: 1%;
    height: 100vh;
    width: 100vw;
}
.pad{
    padding: 2%;
    font-size: larger;
    text-align: center;
    color: black;
}
</style>
